<template>
  <dialog class="modal" ref="editModal">
        <div class="modal-box !overflow-visible">
            <form method="dialog">
            <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 z-10">✕</button>
          </form>
            <!-- name of each tab group should be unique -->
                <div class="tabs tabs-lift mt-[-4rem]">
                <label class="tab bg-base-100 transition-all duration-300 text-black" :class="{ '!bg-secondary !text-white': activeTab }" @click="activeTab=true">
                    <input type="radio" name="my_tabs_4"  :checked="activeTab" />
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                    </svg>
                    Edit
                </label>
                <div class="tab-content bg-base-100 border-base-300 p-6 overflow-scroll transition-opacity duration-300" 
                     style="max-height: 70vh;">
                    <!-- Edit Tab -->
                    <fieldset class="fieldset !mt-4">
                            <legend>Template Title:</legend>
                            <input type="text" v-model="localTitle" class="input input-bordered w-full" />
                        </fieldset>
                        <fieldset class="fieldset !mt-4">
                            <div class="flex justify-between items-center">
                                <div>Template Content:</div>
                                <span class="badge badge-xs badge-primary mx-1">{{ localContent.length }} characters</span>
                            </div>
                            <div class="relative">
                            <textarea 
                                v-model="localContent" 
                                class="textarea textarea-bordered w-full min-h-[200px] !p-[1rem]" 
                                style="color: transparent; caret-color: black;"
                                ref="contentTextarea"
                                @scroll="syncScroll"
                            ></textarea>
                            <div 
                                class="absolute top-0 left-0 h-full pointer-events-none p-[1rem] font-[inherit] whitespace-pre-wrap overflow-hidden break-words"
                                style="height:calc(100% - 2rem) !important;"
                                v-html="highlightedContent"
                                ref="highlightOverlay"
                                @scroll="syncScroll"
                            ></div>
                            <small>use <span class="bg-green-200"> { { Name } } </span> to insert Placeholders.</small>
                            </div>
                        </fieldset>

                        <div class="cursor-pointer bg-base-100 border-base-300 border mt-2" @click="activeTab=false">
                            <summary class="collapse-title font-semibold !min-h-[20px]">Placeholders ({{ variables.length }}): <span class="badge badge-xs badge-primary mx-1" v-for="variable in variables" :key="variable">{{ variable }}</span></summary>
                        </div>
                  
                </div>

                <label class="tab bg-base-100 mx-2 text-black transition-all duration-300" :class="{ '!bg-secondary !text-white': !activeTab }" @click="activeTab=false">
                    <input type="radio" name="my_tabs_4" :checked="!activeTab" />
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 me-2"><path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z" /></svg>
                    Preview
                </label>

                <div class="tab-content bg-base-100 border-base-300 p-6 overflow-scroll transition-opacity duration-300"
                     style="max-height: 70vh;">
                    <!-- Preview Tab -->
                    <summary class="collapse-title font-semibold !min-h-[20px]">Placeholders ({{ variables.length }}): <span class="badge badge-xs badge-primary mx-1" v-for="variable in variables" :key="variable">{{ variable }}</span></summary>
                    
                        
                        <VariablesPanel 
                            :variables="variables"
                            :prompt="localContent"
                            :show="true"
                            :fixed="true"
                        />
                   
                </div>

                
                </div>
         
          
          <div class="modal-action flex justify-between items-center">
            <div class="left-side">
            <button class="btn bg-red-300 hover:bg-red-500 hover:scale-105 transition duration-500 text-white" @click="deleteTemplate"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                </svg>
                Delete
            </button>
            </div>
            <div class="right-side flex gap-2">
                <button class="btn hover:scale-105 transition duration-500" @click="closeModal">Cancel</button>
                <button class="btn btn-primary hover:scale-105 transition duration-500" @click="saveChanges">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0-3-3m3 3 3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z" />
                    </svg>

                    Save
                </button>
            
            </div>
          </div>
          
        </div>
      </dialog>

</template>

<script>
import VariablesPanel from './smart-press/VariablesPanel.vue';

export default {
  name: 'TemplateModal',
  components: {
    VariablesPanel
  },
  props: {
    editTitle: {
      type: String,
      default: 'Edit Template'
    },
    editContent: {
      type: String,
      default: 'Edit the template, Template Content hello {{name}}'
    },
    editId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      customFields: [],
        activeTab: true,
      localTitle: '',
      localContent: '',
      variableValues: {},
      localEditId: null,
      wpUser: window.smartpress_wpUserData ? window.smartpress_wpUserData : {}
    }
  },
  created() {
    this.fetchCustomFields();
  },
  computed: {
    variables() {
      // Extract all variables in the format {{ variableName }}
      const regex = /\{\{\s*([^}]+)\s*\}\}/g;
      const matches = [...this.localContent.matchAll(regex)];
      
      // Extract the variable names and remove whitespace
      const variables = matches.map(match => match[1].trim());
      
      // Remove duplicates by converting to Set and back to Array
      return [...new Set(variables)];
    },
    previewContent() {
      let content = this.localContent;
      
      // Replace each variable with its value or keep the placeholder if no value
      this.variables.forEach(variable => {
        const regex = new RegExp(`\\{\\{\\s*${variable}\\s*\\}\\}`, 'g');
        const value = this.variableValues[variable] || `{{ ${variable} }}`;
        content = content.replace(regex, value);
      });
      
      return content;
    },
    highlightedContent() {
      // Escape HTML to prevent XSS
      let content = this.localContent
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
      
      // Highlight variables with bg-green-200
      const regex = /(\{\{\s*[^}]+\s*\}\})/g;
      content = content.replace(regex, '<span class="bg-green-200">$1</span>');
      
      return content;
    }
  },
  watch: {
    editTitle(newVal) {
      this.localTitle = newVal;
    },
    editContent(newVal) {
      this.localContent = newVal;
    },
    editId(newVal) {
      this.localEditId = newVal;
    },
    variables: {
      handler(newVars) {
        // Create a new object with only the current variables
        const newVariableValues = {};
        
        // Add all current variables (keep existing values)
        newVars.forEach(variable => {
          newVariableValues[variable] = this.variableValues[variable] || '';
        });
        
        // Replace the entire object with the new one
        this.variableValues = newVariableValues;
      },
      immediate: true
    },
    localContent() {
      // Ensure synchronization after content changes
      this.$nextTick(() => {
        this.syncScroll();
      });
    }
  },
  methods: {
    async fetchCustomFields() {
      try {
        let baseUrl = this.wpUser.site_url;
        const response = await fetch(baseUrl + '/wp-json/smartpress/v1/custom-fields', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': window.smartpress_wpApiSettings?.nonce || ''
          }
        });
        
        if (!response.ok) {
          throw new Error('Failed to fetch custom fields');
        }
        
        const data = await response.json();
        this.customFields = data;
        console.log(data);
      } catch (error) {
        console.error('Error fetching custom fields:', error);
        this.error = 'Failed to load Account Info, Please contact support.';
      } 
    },
    showModal() {
        this.activeTab = true;
      this.localTitle = this.editTitle;
      this.localContent = this.editContent;
      
      // Reset variable values when showing modal
      const resetValues = {};
      this.variables.forEach(variable => {
        resetValues[variable] = '';
      });
      this.variableValues = resetValues;
      
      this.$refs.editModal.showModal();
      
      // Ensure highlighting is properly synchronized
      this.$nextTick(() => {
        this.syncScroll();
      });
    },
    closeModal() {
      this.$refs.editModal.close();
    },
    async saveChanges() {
      this.$emit('update:editTitle', this.localTitle);
      this.$emit('update:editContent', this.localContent);
      this.$emit('save');
        
      this.closeModal();
    },
    async deleteTemplate() {
        this.$emit('delete');
        this.closeModal();
    },
    syncScroll() {
      if (this.$refs.contentTextarea && this.$refs.highlightOverlay) {
        const textarea = this.$refs.contentTextarea;
        const overlay = this.$refs.highlightOverlay;
        
        // Sync scroll position
        overlay.scrollTop = textarea.scrollTop;
      }
    },
  },
  mounted() {
    this.localTitle = this.editTitle;
    this.localContent = this.editContent;
  }
}
</script>

<style scoped>
.textarea {
  font-size: inherit !important;
  font-family: inherit !important;
  line-height: inherit !important;
}

.tab-content {
  position: relative;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.tab-content.opacity-0 {
  pointer-events: none;
  position: absolute;
  transform: translateY(10px);
}

.tab-content.opacity-100 {
  transform: translateY(0);
}

.tab {
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease, transform 0.2s ease;
}

.tab:hover {
  transform: translateY(-2px);
}
</style>